/**
 * Lemon Squeezy payment configuration for frontend
 */

export const LEMONSQUEEZY_CONFIG = {
  storeSlug: process.env.REACT_APP_LEMONSQUEEZY_STORE_SLUG || 'sente',
  // Product UUIDs for checkout URLs (not variant IDs)
  products: {
    pro: process.env.REACT_APP_LEMONSQUEEZY_PRODUCT_PRO || '26ccb71b-a7cb-49ac-80b6-d3d4e8f8d727',
    team: process.env.REACT_APP_LEMONSQUEEZY_PRODUCT_TEAM || '4b0966e3-308d-4f6e-84a2-579cedd65304',
  }
};

/**
 * Build Lemon Squeezy checkout URL with embedded overlay parameters
 */
export function buildCheckoutUrl(
  variantId: string,
  options: {
    email?: string;
    userId?: string;
    planId?: string;
  }
): string {
  // Get product UUID based on plan
  const productUuid = options.planId === 'team'
    ? LEMONSQUEEZY_CONFIG.products.team
    : LEMONSQUEEZY_CONFIG.products.pro;

  const baseUrl = `https://${LEMONSQUEEZY_CONFIG.storeSlug}.lemonsqueezy.com/checkout/buy/${productUuid}`;

  const params = new URLSearchParams();
  params.set('embed', '1');      // Enable overlay mode
  params.set('media', '0');      // Hide media/images
  params.set('desc', '0');       // Hide description
  params.set('discount', '0');   // Hide discount field
  params.set('dark', '1');       // Dark mode
  params.set('enabled', variantId); // Pre-select the variant

  if (options.email) {
    params.set('checkout[email]', options.email);
  }
  if (options.userId) {
    params.set('checkout[custom][userId]', options.userId);
  }
  if (options.planId) {
    params.set('checkout[custom][planId]', options.planId);
  }

  return `${baseUrl}?${params.toString()}`;
}

/**
 * Initialize Lemon.js SDK
 * Call this before opening checkout
 */
export function initLemonSqueezy(): boolean {
  if (window.createLemonSqueezy) {
    window.createLemonSqueezy();
    return true;
  }
  return false;
}

/**
 * Check if Lemon Squeezy SDK is ready
 */
export function isLemonSqueezyReady(): boolean {
  return !!window.LemonSqueezy;
}

/**
 * Open Lemon Squeezy checkout overlay
 */
export function openCheckout(url: string): void {
  if (window.LemonSqueezy) {
    window.LemonSqueezy.Url.Open(url);
  } else {
    console.error('Lemon Squeezy SDK not initialized');
  }
}
